module.exports = __webpack_public_path__ + "files/4008b4fdc45bdd6f79f5f1125b0303f7.png";